"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EHeadingType = void 0;
let EHeadingType = exports.EHeadingType = /*#__PURE__*/function (EHeadingType) {
  /**
   * @description Войдите, чтобы использовать больше фильтров
   * @type {EHeadingType.AdvancedFiltersAuthPermission}
   */
  EHeadingType["AdvancedFiltersAuthPermission"] = "advancedFiltersAuthPermission";
  /**
   * @description Войдите, чтобы посмотреть номер телефона
   * @type {EHeadingType.PhoneAuthPermission}
   */
  EHeadingType["PhoneAuthPermission"] = "phoneAuthPermission";
  /**
   * @description Войдите, чтобы посмотреть информацию
   * @type {EHeadingType.InformationPermission}
   */
  EHeadingType["InformationPermission"] = "informationPermission";
  /**
   * @description Вход или регистрация для покупки отчёта
   * @type {EHeadingType.BuyCommercialAnalyticsPermission}
   */
  EHeadingType["BuyCommercialAnalyticsPermission"] = "buyCommercialAnalyticsPermission";
  /**
   * @description У вас уже есть аккаунт, авторизуйтесь
   * @type {EHeadingType.ThereIsAnAccount}
   */
  EHeadingType["ThereIsAnAccount"] = "thereIsAnAccount";
  /**
   * @description Войдите, чтобы разместить объявление
   * @type {EHeadingType.NewOfferForm}
   */
  EHeadingType["NewOfferForm"] = "newOfferForm";
  /**
   * @description Войдите, чтобы сохранить поиск
   * @type {EHeadingType.SaveSearchPermission}
   */
  EHeadingType["SaveSearchPermission"] = "saveSearchPermission";
  /**
   * @description Войдите, чтобы подобрать риелтора
   * @type {EHeadingType.SelectRealtor}
   */
  EHeadingType["SelectRealtor"] = "selectRealtor";
  /**
   * @description Войдите, чтобы добавить в избранное
   * @type {EHeadingType.AddFavorite}
   */
  EHeadingType["AddFavorite"] = "addFavorite";
  /**
   * @description Войдите, чтобы сравнить объявления
   * @type {EHeadingType.CompareOffers}
   */
  EHeadingType["CompareOffers"] = "compareOffers";
  /**
   * @description Войдите, чтобы оставить заметку
   * @type {EHeadingType.AddNote}
   */
  EHeadingType["AddNote"] = "addNote";
  /**
   * @description Войдите, чтобы получать уведомления
   * @type {EHeadingType.Notifications}
   */
  EHeadingType["Notifications"] = "notifications";
  /**
   * @description Войдите, чтобы скрывать объявления
   * @type {EHeadingType.HideOffers}
   */
  EHeadingType["HideOffers"] = "hideOffers";
  /**
   * @description Войдите, чтобы получать обновления цены
   * @type {EHeadingType.SubscribePriceChange}
   */
  EHeadingType["SubscribePriceChange"] = "subscribePriceChange";
  /**
   * @description Войдите, чтобы посмотреть историю цены
   * @type {EHeadingType.SeePriceHistory}
   */
  EHeadingType["SeePriceHistory"] = "seePriceHistory";
  /**
   * @description Войдите, чтобы посмотреть историю арендной ставки
   * @type {EHeadingType.SeeRentalRateHistory}
   */
  EHeadingType["SeeRentalRateHistory"] = "seeRentalRateHistory";
  /**
   * @description Войдите, чтобы следить за изменением цены
   * @type {EHeadingType.MonitorPriceChanges}
   */
  EHeadingType["MonitorPriceChanges"] = "monitorPriceChanges";
  /**
   * @description Войдите, чтобы посмотреть телефон
   * @type {EHeadingType.SeePhoneNumber}
   */
  EHeadingType["SeePhoneNumber"] = "seePhoneNumber";
  /**
   * @description Войдите, чтобы позвонить
   * @type {EHeadingType.ToCall}
   */
  EHeadingType["ToCall"] = "toCall";
  /**
   * @description Войдите, чтобы подключить онлайн-бронирование
   * @type {EHeadingType.ToJoinOta}
   */
  EHeadingType["ToJoinOta"] = "toJoinOta";
  return EHeadingType;
}({});